import React from "react";
import { inject, observer } from "mobx-react";
import DoneIcon from "@material-ui/icons/Done";
import { Table, TableHead, TableCell, TableRow, TableBody, Grid, Paper, Typography } from "@material-ui/core";
import { IManagementStore } from "Stores/Management/types";
import ResultsAreEmpty from "@src/Components/Ui/ResultsAreEmpty";
import { Values } from "@src/Tools/Values";
import { STTableHeadTypography } from "@src/Components/Ui/STTableHeadTypography";
import AddAuthProvider from "./AddAuthProvider/AddAuthProvider";
import { AuthProvider } from "@src/Interfaces/Entity/OAuthProvider";
import EntityDelete from "@src/Components/Common/EntityDelete/EntityDelete";
import EditOAuthProvider from "./EditAuthProvider/EditAuthProvider";
import { IValuesStore } from "@src/Stores/Values/types";
import { IAuthStore } from "@src/Stores/Auth/types";
import { STTableCellTypography } from "@src/Components/Ui/STTableCellTypography";
import AuthProvidersHelpModal from "./AuthProvidersHelpModal/AuthProvidersHelpModal";
import { STItemGrid,STGrid } from "./styles";

interface IProps {
  management?: IManagementStore;
  values?: IValuesStore;
  auth?: IAuthStore;
}

@inject("auth", "management", "values")
@observer
class AuthProvidersContent extends React.Component<IProps> {
  handleRemove = async (id: string) => {
    await this.props.management.removeOAuthProvider(id);
  };

  handleGetType = (type: number) => {
    return Object.entries(this.props.values.oAuthProviderTypes).filter(
      (entry: [string, number]) => entry[1] === type
    )[0][0];
  };

  handleRequired = (required: boolean) => {
      return required == true ? <DoneIcon /> : null;
  };

  render() {
    return (
        <Grid container direction="column">
            <Grid container wrap="nowrap">
                <Grid item xs={6}>
                    <STGrid container justify="flex-start" align="flex-end">
                        <STItemGrid item xs={3}>
                            <AuthProvidersHelpModal />
                        </STItemGrid>
                    </STGrid>
                </Grid>
                <Grid item xs={6}>
                    <Grid container justify="flex-end">
                        {this.props.auth.user.location.primary && <AddAuthProvider />}
                    </Grid>
                </Grid>
            </Grid>
            <Grid container wrap="nowrap" justify="flex-end" item>
        </Grid>
        <Grid item xs>
          {this.props.management.oAuthProviders.length > 0 ? (
            <Paper elevation={2}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <STTableHeadTypography>{Values.getLocalizationValue("name")}</STTableHeadTypography>
                    </TableCell>
                    <TableCell>
                      <STTableHeadTypography>{Values.getLocalizationValue("type")}</STTableHeadTypography>
                    </TableCell>
                    <TableCell>
                      <STTableHeadTypography>{Values.getLocalizationValue("required")}</STTableHeadTypography>
                    </TableCell>
                    <TableCell align="right" />
                  </TableRow>
                </TableHead>
                <TableBody>
                  {this.props.management.oAuthProviders.map((oAuthProvider: AuthProvider) => {
                    return (
                      <TableRow key={oAuthProvider.id}>
                        <TableCell component="th" scope="row" size="small">
                          <STTableCellTypography>{oAuthProvider.name}</STTableCellTypography>
                        </TableCell>
                        <TableCell size="small">
                          <STTableCellTypography>{this.handleGetType(oAuthProvider.type)}</STTableCellTypography>
                        </TableCell>
                        <TableCell size="small">
                          <STTableCellTypography>{this.handleRequired(oAuthProvider.isRequired)}</STTableCellTypography>
                        </TableCell>
                        <TableCell align="right" size="small">
                          <Grid container wrap="nowrap" justify="flex-end">
                            {this.props.auth.user.location.primary && (
                              <>
                                <EditOAuthProvider oAuthProvider={oAuthProvider} />
                                <EntityDelete onSubmit={() => this.handleRemove(oAuthProvider.id)} />
                              </>
                            )}
                          </Grid>
                        </TableCell>
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </Paper>
          ) : (
            <ResultsAreEmpty />
          )}
        </Grid>
      </Grid>
    );
  }
}

export default AuthProvidersContent;
